import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

import TextEditor from 'components/TextEditor';
import InfoBar from 'components/InfoBar';
import './style.scss';

class Contribute extends Component {

  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubjectUpdate = this.handleSubjectUpdate.bind(this);
    this.handleInfoBarClose = this.handleInfoBarClose.bind(this);
  }

  componentDidMount() {
    if(this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  handleSubmit(text) {
    const subject = this.props.subject;
    this.props.onSubmit(subject, text);
  }

  handleSubjectUpdate(e) {
    const subject = e.target.value;
    this.props.onSubjectUpdate(subject);
  }

  handleInfoBarClose() {
    if(this.props.onInfoBarClose) {
      this.props.onInfoBarClose();
    }
  }

  render() {
    const { title, isNarrow, hasBackgroundWhite, ...otherProps } = this.props;

    const wrapperClassName = classnames('is-padded-top', {
      'wrapper-narrow': isNarrow,
      'wrapper-small': !isNarrow,
      'has-background-white': hasBackgroundWhite
    });

    return (
      <div className="Contribute">
        {this.props.isSuccessInfoBarVisible && <InfoBar onClose={this.handleInfoBarClose} isStatic type="primary" title={this.props.successInfoBarTitle} message={this.props.successInfoBarMessage} />}

        <div className={wrapperClassName}>

          <div className="contribute-form">
            <h1>{title}</h1>

            <div className="form-inner">
              <label>{__('members.textEditor.subjectLabel')}</label>
              <input
                type="text"
                placeholder={__('members.textEditor.subjectPlaceholder')}
                value={this.props.subject}
                onChange={this.handleSubjectUpdate}
              />

              <TextEditor
                {...otherProps}
                onSubmit={this.handleSubmit}
                maxChars={process.env.KOOTH_MAX_CHARS}
                contentTitle={__('members.textEditor.contentLabel')}
                placeholder={__('members.textEditor.contentPlaceholder')}
              />


            </div>
          </div>
        </div>
      </div>
    );
  }

}

Contribute.propTypes = {
  subject: PropTypes.string,
  isSuccessInfoBarVisible: PropTypes.bool,
  successInfoBarMessage: PropTypes.string,
  successInfoBarTitle: PropTypes.string,
  title: PropTypes.string,
  isNarrow: PropTypes.bool,
  hasBackgroundWhite: PropTypes.bool,
  onSubjectUpdate: PropTypes.func,
  onSubmit: PropTypes.func,
  onDidMount: PropTypes.func,
  onInfoBarClose: PropTypes.func
};

export default Contribute;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Contribute/index.js
 **/